import { useState } from 'react';

export default function useDevicePermissions() {
  const [permissionsGranted, setPermissionsGranted] = useState(false);
  const [error, setError] = useState(null);

  const requestPermissions = async () => {
    try {
      // 1. Pedir permiso de giroscopio PRIMERO (iOS requiere esto antes de la cámara)
      if (typeof DeviceOrientationEvent !== 'undefined' &&
          typeof DeviceOrientationEvent.requestPermission === 'function') {
        const response = await DeviceOrientationEvent.requestPermission();
        if (response !== 'granted') {
          setError('Necesitamos acceso al giroscopio para la experiencia');
          return false;
        }
      }

      // 2. Pedir permiso de cámara
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ 
          video: { facingMode: 'environment' }
        });
        stream.getTracks().forEach(track => track.stop());
      } catch (cameraError) {
        setError('Necesitamos acceso a la cámara para la experiencia AR');
        return false;
      }

      setPermissionsGranted(true);
      return true;
    } catch (err) {
      console.error('Error requesting permissions:', err);
      setError(err.message);
      return false;
    }
  };

  return { permissionsGranted, error, requestPermissions };
}